// import Vue from 'vue';

import { th } from '@/helper/locale/th_1054';
import { en } from '@/helper/locale/en_1033';

/**
 * @function getLocale
 * @function getLocaleCode
 * @function getLbl
 * @function getLocaleShort
 * @function setLocale
 */
export default {
    // KEY_COOKIE_LOCALE: 'BzbsLocale',
    // KEY_COOKIE_LOCALE: 'BzbsProfileExtensionJson',
    KEY_COOKIE_LOCALE: 'BzbsUserDetail',
    defaultLocale: {
        code: 1054,
        short: 'th',
    },
    // getLocale: function() {
    //     // var locale = Vue.$cookies.get(this.KEY_COOKIE_LOCALE);
    //     var locale = window.localStorage.getItem(this.KEY_COOKIE_LOCALE);
    //     var getProfileTier = JSON.parse(localStorage.getItem(this.KEY_COOKIE_LOCALE));
    //     console.log(getProfileTier);
        
    //     var localeCustom = '';
    //     if (getProfileTier.Meta && getProfileTier.Meta.Tier && getProfileTier.Meta.Tier.LANG) {
    //         localeCustom = getProfileTier.Meta.Tier.LANG.toLowerCase();
    //     } else {
    //         localeCustom == 'th';
    //     }
    //     if (localeCustom == 'th') {
    //         locale = {
    //             code: 1054,
    //             short: localeCustom,
    //         }
    //     } else {
    //         locale = {
    //             code: 1033,
    //             short: localeCustom,
    //         }
    //     }
    //     if (locale == null) {
    //         locale = this.defaultLocale;
    //     } 
    //     return locale;
    // },
    getLocale: function() {
        // var locale = Vue.$cookies.get(this.KEY_COOKIE_LOCALE);
        var localeItem = window.localStorage.getItem(this.KEY_COOKIE_LOCALE);
        // console.log('localeItem', localeItem);
        var getProfileTier = null;
        
        // Safely parse the localStorage item
        if (localeItem) {
            try {
                getProfileTier = JSON.parse(localeItem);
            } catch (e) {
                // console.log('Failed to parse locale from localStorage:', e);
                getProfileTier = null;
            }
        }
        
        // console.log(getProfileTier);
        
        var localeCustom; // Default to 'th'
        // Only access Meta if getProfileTier is not null
        if (getProfileTier && getProfileTier.Meta && getProfileTier.Meta.Tier && getProfileTier.Meta.Tier.LANG) {
            localeCustom = getProfileTier.Meta.Tier.LANG.toLowerCase();
        }
        
        var locale;
        if (localeCustom == 'th') {
            locale = {
                code: 1054,
                short: localeCustom,
            }
        } else {
            locale = {
                code: 1033,
                short: localeCustom,
            }
        }
        if (locale == null) {
            locale = this.defaultLocale;
        } 
        return locale;
    },
    getLocaleCode: function() {
        var localeObj = this.getLocale();
        return localeObj.code;
    },
    getLbl: function() {
        if (this.getLocaleCode() == 1033) {
            return en;
        } else {
            return th;
        }
    },
    getLocaleShort: function() {
        var localeObj = this.getLocale();
        return localeObj.short;
    },
    setLocale: function(localeCode) {
        var localeObj = {
            code: 1054,
            short: 'th',
        };
        if (localeCode == 1033) {
            localeObj = {
                code: 1033,
                short: 'en',
            };
        }
        let strLocale = JSON.stringify(localeObj);
        // Vue.$cookies.set(this.KEY_COOKIE_LOCALE, strLocale);
        window.localStorage.setItem(this.KEY_COOKIE_LOCALE, strLocale);
    },
}
